export default { 
  ha88e2ffd1d09deb88bf908f50136bdab: [[({}, []) => ["Account > Settings > Login preferences. "], {}]],
  hb5c1c51a0478bac0dc537ed65ea9ca0f: [[({}, []) => ["Manage Account > Security."], {}]],
  hf580fb264b5b05fbd87fb3d98a67c536: [[({}, []) => ["Your Account > Security Settings."], {}]] 
}